import React from "react";
import { LanguageContext } from "./languageProvider";

export default function useLanguage(){
    const context = React.useContext(LanguageContext);
    if (!context) {
      throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};